module.exports = __webpack_public_path__ + "static/media/panel.734a71d4.svg";